import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField';
import { DropdownOption } from '@wix/da-ds/pkg/Dropdown/types';
import { useSubmitField } from '../../../hooks/useSubmitField';

export enum OAuth2GrantType {
  AUTHORIZATION_CODE = 'authorization_code',
  IMPLICIT = 'implicit',
}

const OAuthGrantTypeField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const {
    id,
    field: { value, onChange },
  } = useSubmitField('oauth2GrantType', {
    initAdapter: ({ app }) => app?.oauth2GrantType ?? OAuth2GrantType.AUTHORIZATION_CODE,
    submitAdapter: ({ oauth2GrantType }) => ({
      oauth2_grant_type: oauth2GrantType,
    }),
  });

  const items = useMemo<DropdownOption[]>(
    () => [
      {
        label: t('deviationSubmit.form.app.oauth2GrantType.authorization_code'),
        value: OAuth2GrantType.AUTHORIZATION_CODE,
        selected: value === OAuth2GrantType.AUTHORIZATION_CODE,
      },
      {
        label: t('deviationSubmit.form.app.oauth2GrantType.implicit'),
        value: OAuth2GrantType.IMPLICIT,
        selected: value === OAuth2GrantType.IMPLICIT,
      },
    ],
    [t, value]
  );

  return (
    <SelectField
      id={id}
      label={t('deviationSubmit.form.app.oauth2GrantType.label')}
      items={items}
      value={value}
      onSelect={onChange}
      withBlankOption={false}
      noBottomSpacing={false}
    />
  );
};
OAuthGrantTypeField.displayName = 'OAuthGrantTypeField';

export default OAuthGrantTypeField;
